<template>
  <EuiContainer >
    <EuiGrid  class="mx-0 mt-2">
      <EuiBlock  class="w-1/2" title="Infos sur une IP">
        <form @submit.prevent="searchIp">
          <EuiGridRow class="mt-3">
            <EuiTextField
                v-model="ip"
                label="IP à chercher"
                placeholder="Adresse IP v4"
                adaptSize
                class="mr-3"
            />
          </EuiGridRow>
          <EuiGridRow justify="end" class="my-5" >
            <EuiButton
                :disabled="isDisabledButtonSearch"
                color="primary"
                variant="raised"
                type="submit">
              Rechercher l'ip
              <EuiTooltip
                  v-show="errors"
                  :content="mixinsIpGetErrorMessage"
                  placement="top">
                <template slot="anchor">
                  <EuiIcon class="eui-u-ml-4" name="help" size="medium"/>
                </template>
              </EuiTooltip>
            </EuiButton>
          </EuiGridRow>
        </form>
      </EuiBlock>
      <EuiBlock  v-if="getterIsLaunch" class="w-full mt-3" :title="`Résultat pour l'ip ${ip}`">
        <template v-slot:actions>
          <form  @submit.prevent="validation">
            <EuiGridRow class="my-2"  justify="between" >
              <EuiButton
                  color="primary"
                  variant="raised" >
                Déverrouiller
              </EuiButton>
            </EuiGridRow>
          </form>
        </template>
        <div v-if="JSON.stringify(ipInfos) === JSON.stringify({})"> Aucun résultat</div>
        <div v-else>
          <div>Date de la dernière tentative de connexion = {{ ipInfos.lastTry }}</div>
          <div>Nombre d'essais infructueux = {{ ipInfos.nbTries }}</div>
          <div>Bloquée pour 24h = {{ ipInfos.isTemporaryBlocked }}</div>
          <div>Whitelistée = {{ ipInfos.isWhiteListed }}</div>
          <div>Blacklistée = {{ ipInfos.isBlackListed }}</div>
        </div>
      </EuiBlock>
    </EuiGrid>
    <ConfirmationDialog
        :isOpen="isConfirmationDialogOpen"
        @confirmation="confirmation"
        @close-dialog="closeDialog">
      <span v-html="confirmationMessage"></span>
    </ConfirmationDialog>
  </EuiContainer>
</template>

<script>
import ips from '@/mixins/ips';
import apiIp from '@/api/ip';
import store from '@/store';
import { mapGetters } from 'vuex';
import ConfirmationDialog from '@/components/confirmationDialog.vue';


export default {
  name: 'pages.ip.unlock',
  mixins: [ips],
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      ip: '',
      ipInfos: {},
      errors: false,
      isConfirmationDialogOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      getterSession: 'auth/session',
      getterIsLoading: 'application/isLoading',
      getterIsLaunch: 'application/isLaunch',
    }),
    isDisabledButtonSearch() {
      if (this.ip === '') { return true; }
      this.mixinsIpsIsValidIpv4(this.ip);
      return this.errors;
    },
    confirmationMessage() {
      return `Déblocage de l'ip <b>${this.ip}</b> ?`;
    },
  },
  methods: {
    closeDialog() {
      this.isConfirmationDialogOpen = false;
    },
    confirmation() {
      this.closeDialog();
      this.unlockIp();
    },
    validation() {
      this.isConfirmationDialogOpen = true;
    },
    parameters() {
      return {
        ip: this.ip,
        sessionId: this.getterSession.token,
      };
    },
    searchIp() {
      this.storeStartSearch();
      this.storeStartLoading();
      apiIp.getInfosIp(this.parameters()).then((response) => {
        this.storeFinishLoading();
        if (response.code === 99) {
          store.dispatch('application/pushAlert', { message: 'L\'adresse cherchée n\'existe pas', type: 'info' });
        } else {
          this.ipInfos = response.content;
        }
      }).catch(() => store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' }));
    },
    formHasError() {
      return this.errors;
    },
    unlockIp() {
      apiIp.unlockIp(this.parameters()).then(() => {
        store.dispatch('application/pushAlert', { message: 'L\'adresse ip a bien été débloquée', type: 'success' });
        this.searchIp();
      }).catch(() => store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' }));
    },
    clearResult() {
      this.storeResetSearch();
      this.ipInfos = {};
      this.errors = false;
    },

  },
};
</script>
